module.exports = __webpack_public_path__ + "img/imge7.15bd1289.png";